import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { DateRange, LocalDate, PagedList, SpendingFullModel, SpendingModel } from '../interface';
import { toHttpParams } from '../utils/globals';
import { AdmResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxSpendService {

  constructor(
    private http: HttpClient,
    private admApi: AdmResourceService,
  ) {
  }

  getSpendStoreList(params: SpendingRequest): Promise<PagedList<SpendingFullModel>> {
    return firstValueFrom(this.admApi.getStoreSpending(
      undefined, params?.date?.from, params?.date?.to, params?.incomingNumber,
      params?.limit, params?.orderBy, params?.organizationId, params?.page,
      params?.paidDate, undefined, undefined, params?.sort as any,
      undefined, params?.storeIds,
    )) as unknown as Promise<PagedList<SpendingFullModel>>;
  }

  getSpendById(spendId: number): Promise<SpendingFullModel> {
    return firstValueFrom(this.admApi.getSpendingById(spendId)) as unknown as Promise<SpendingFullModel>;
  }

  saveSpendStore(body: SaveStoreSpendingRequest): Promise<SpendingModel> {
    return firstValueFrom(this.admApi.saveStoreSpending(body as any)) as unknown as Promise<SpendingModel>;
  }

  spendPaid(spendId: number, body: any): Promise<any> {
    return firstValueFrom(this.admApi.paidSpending(spendId, body));
  }

  spendPaidCancelled(spendId: number): Promise<any> {
    return firstValueFrom(this.admApi.paidCancelled(spendId));
  }

  remove(spendId: number): Promise<void> {
    return firstValueFrom(this.admApi.removeSpending(spendId));
  }
}

interface SpendingRequest {
  storeIds?: number[];
  date?: DateRange;
  organizationId?: number;
  spendCategoryId?: number;
  page?: number;
  limit?: number;
  sort?: string;
  orderBy?: string;
  incomingNumber?: string;
  paidDate?: string;
}

interface SaveStoreSpendingRequest {
  id?: number;
  spendCategoryCode: string;
  storeId: number;
  total: number;
  date: LocalDate;
  incomingNumber?: string;
  cashFlowCategoryCode?: string;
  payBefore: LocalDate;
}
